import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

/**
 * Coздает элемент в корне документа или возвращает
 * ссылку на него, если он существует
 * @param id Идентификатор элемента
 * @param tag Тег создаваемого элемента
 */
export const createRootElement = (id: string, tag: keyof HTMLElementTagNameMap = 'div') => {
    if (!isClientSide()) {
        return null;
    }

    let root = document.getElementById(id);

    if (!root) {
        root = document.createElement(tag);
        root.setAttribute('id', id);
        document.body.appendChild(root);
    }

    return root;
};
